;(function () {
    $(function() {
        $(document).on('click', '.i-video-delete', function(e) {
            e.preventDefault();

            var $btn = $(this);
            var url = $btn.data('url');

            if (!url) {
                return;
            }

            $.ajax({
                url: url,
                dataType: 'json',
                method:     'POST',
                data: {},
                cache:   false,
                success: function(result) {
                    $btn.closest('.i-video-item').remove();
                },
                error: function(xhr) {
                    var isErrorDefined = typeof xhr != "undefined" &&
                        typeof xhr.responseJSON != "undefined" &&
                        typeof xhr.responseJSON.error != "undefined" &&
                        xhr.responseJSON.error.length;

                    if (isErrorDefined) {
                        $('.b-media-overlay-video-delete').find('.b-media-overlay-video-error').html(xhr.responseJSON.error);
                    } else {
                        $('.b-media-overlay-video-delete').find('.b-media-overlay-video-error').html('Произошла ошибка. Попробуйте еще раз.');
                    }

                    $('.b-media-overlay-video-delete').fadeIn('fast');

                    console.warn('video delete error', arguments);
                }
            });
        });

        $(document).on('click', '.b-media-overlay-video-delete .b-media-overlay-popup__close', function(e) {
            if (e.target === this) {
                $(this).closest('.b-media-overlay-video-delete').fadeOut('fast');
                return false;
            }
        });

    });
})();
